<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_EXPERTS"
    title="Experts"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Experts"
    align="left"
    width="fixed"
  >
    <SmartFeed
      :source="useOrgCommunityExpertiseFeedStore"
      default-entity-size="large"
      default-feed-layout="grid"
      load-more-behavior="auto"
    >
      <template #empty-state>
        <iSpace :height="10" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No experts found
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              There are currently no experts available in the community
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  SECTION_COMMUNITY,
  PAGE_EXPERTS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useOrgCommunityExpertiseFeedStore } from "SmartFeed/stores/feed/org-community-expertise-feed-store";

export default {
  name: "Experts",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_EXPERTS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: "/experts", label: "Experts" },
      ];
    },
  },
  methods: { useOrgCommunityExpertiseFeedStore },
};
</script>

